import { render, staticRenderFns } from "./UnableToAttendButton.vue?vue&type=template&id=2491fe65&"
import script from "./UnableToAttendButton.vue?vue&type=script&lang=js&"
export * from "./UnableToAttendButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports